import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CTAs/DownloadAppHorizontalCTA/assets/AppsBannerBackground.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/CTAs/DownloadAppHorizontalCTA/assets/logo.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CircleImage"] */ "/app/src/views/FeaturePages/components/CircleImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/DepthMapsPage/assets/depthMapBackground.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/DepthMapsPage/assets/depthMapsPhoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/FishingForecastsPage/assets/fishingForecastsPhoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/FishingSpotsPage/assets/fishingSpotsPhoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/FishingSpotsPage/assets/fishingSpotsPhoneTwo.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/LogbookPage/assets/logbookPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/WaypointsPage/assets/waypointsPhoneTwo.png");
